// src/pages/SharedPage.jsx

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SharedConversation from "./SharedConversation";

const API_BASE = "http://localhost:4000";
//const API_BASE = "https://myjourneytrails.com";

export default function SharedPage() {
  const { token } = useParams();

  const [messages, setMessages] = useState([]);
  const [sessionEnded, setSessionEnded] = useState(false);
  const [isJournaler, setIsJournaler] = useState(false);
  const [journalerName, setJournalerName] = useState("Journaler");
  const [companionName, setCompanionName] = useState("Companion");

  // Load initial conversation + messages
  useEffect(() => {
    async function load() {
      const res = await fetch(`${API_BASE}/api/shared/${token}`, {
        credentials: "include"
      });
      const data = await res.json();

      const convo = data.conversation;

      setMessages(data.messages || []);
      setSessionEnded(!!convo.ended_at);

      setIsJournaler(convo.viewer_is_journaler === true);

      setJournalerName(convo.journaler_name || "Journaler");
      setCompanionName(convo.companion_name || "Companion");
    }
    load();
  }, [token]);

  return (
    <div className="page-wrap">
      <SharedConversation
        token={token}
        messages={messages}
        setMessages={setMessages}
        sessionEnded={sessionEnded}
        isJournaler={isJournaler}
        journalerName={journalerName}
        companionName={companionName}
      />
    </div>
  );
}
